function page_load(collection_grid) {
    if (sessionStorage.getItem('back_col_url') == window.location.href) {
      collection_grid.innerHTML = sessionStorage.getItem('back_col_html');
      collection_grid.setAttribute('data-next-url', sessionStorage.getItem('back_col_next_url'));
      if (collection_grid.getAttribute('data-next-url') == '') {
        var load_button = document.querySelector(".custom-filter-load-more")
        if(load_button){
            load_button.style.display = 'none'
        }
      }
    }
    sessionStorage.removeItem('back_col_html');
    sessionStorage.removeItem('back_col_url');
    sessionStorage.removeItem('back_col_next_url');
    window.onunload = function () {
      sessionStorage.setItem('back_col_html', collection_grid.innerHTML);
      sessionStorage.setItem('back_col_url', window.location.href);
      sessionStorage.setItem('back_col_next_url', collection_grid.getAttribute('data-next-url'));
    };
}
// page_load(document.querySelector('.collection-grid'));

document.addEventListener('DOMContentLoaded', function() {

    // Load more products

    const load_btn = document.querySelector(".custom-filter-load-more");

    let products_on_page = document.querySelector('.collection-grid');

    let url = products_on_page.getAttribute('data-next-url');

    const spinner = document.querySelector('.load-more-spinner');

    if (load_btn) {
        if (url === '') {
            load_btn.style.display = 'none';
        }

        load_btn.addEventListener("click", ()=> {

            //spinner.classList.add("show");

            fetch(url)
                .then(function (response) {
                    if (response.ok) {
                        return response.text();
                    } else {
                        throw new Error('Network response was not ok.');
                    }
                })
                .then(function (data) {
                    const html = document.createElement('div');
                    html.innerHTML = data;

                    let links = html.querySelector('.pagination-links').innerHTML;

                    document.querySelector('.pagination-links').innerHTML = links;

                    let new_grid = html.querySelector('.collection-grid');
                    url = new_grid.getAttribute('data-next-url');
                    document.querySelector('.collection-grid').setAttribute('data-next-url',url)
                    if (url === '') {
                        load_btn.style.display = 'none';
                    }
                    let new_products = new_grid.querySelectorAll(".product-card, #collection-advert, #collection-advert-2, #collection-advert-3, #collection-advert-4");

                    // re-update the product card index to take into account the existing products
                    let lastProductIndex = 0;
                    document.querySelectorAll(".product-card").forEach(prod => {
                        const index = prod.getAttribute('data-index');
                        if (index) {
                            lastProductIndex = Math.max(lastProductIndex, parseInt(index));
                        }
                    });

                    let newProductIndex = lastProductIndex + 1;

                    new_products.forEach(new_prod => {
                        new_prod.setAttribute('data-index', newProductIndex);
                        products_on_page.append(new_prod);
                        newProductIndex++;
                    });
                    //spinner.classList.remove("show");

                    document.dispatchEvent(new Event('loaded_more_products'));
                })
                .catch(function (error) {
                    window.log(error);
                });


        })
    }

    let custom_filters = document.querySelectorAll(".custom-filter")

    custom_filters.forEach((el)=>{

        let control = el.querySelector(".filter-heading")
        let body = el.querySelector(".filter-body")

        if(control && body){


            control.addEventListener('click', () => {

                if (!el.classList.contains("open")) {
                    custom_filters.forEach((el)=>{
                        if(el.classList.contains("open")){
                            el.classList.remove("open")
                        }
                    })
                    el.classList.add("open")
                } else {
                    el.classList.remove("open")
                }


            })
        }
    })

    let mobile_control = document.querySelector(".mobile-filter-heading")
    let filter_body = document.querySelector(".custom-filter-wrapper")
    let promoBar = document.querySelector(".promotional-bar")
    let announcementBar = document.querySelector(".announcement-bar")
    if(mobile_control && filter_body){
        mobile_control.addEventListener('click', () => {
            // rotate svg
            if(mobile_control.classList.contains("open")){
                mobile_control.classList.remove("open")
            } else {
                mobile_control.classList.add("open")
            }

            // open filters
            if(filter_body.classList.contains("open")){
                filter_body.classList.remove("open")
                promoBar.classList.remove("open")
                announcementBar.classList.remove("open")
            } else {
                filter_body.classList.add("open")
                promoBar.classList.add("open")
                announcementBar.classList.add("open")
            }
        })
    }

    // Hide reset filters when no filters active
    const reset_filters = document.querySelector('.reset-filter-wrapper');
    const selected_filters_html = document.querySelectorAll('.selected-filter-wrapper *');

    if (selected_filters_html.length > 0) {
        reset_filters.style.display = 'block';
    }

    const collection_grid = document.querySelector('.collection-grid');

    selected_filters_html.forEach(selected => {
        selected.addEventListener('click', () => {
            if (collection_grid) {
                collection_grid.classList.add("loading");
            }
        })
    })

    function handleNewProductCard(mutationsList) {
        mutationsList.forEach(function (mutation) {
            mutation.addedNodes.forEach(function (node) {
                if (node.nodeType === 1 && node.classList.contains('product-card')) {
                    const trustpilotWidget = node.querySelector('.trustpilot-widget');

                    if (trustpilotWidget) {
                        Trustpilot.loadFromElement(trustpilotWidget);
                    }
                }
            });
        });
    }

    const observer = new MutationObserver(handleNewProductCard);

    const config = { childList: true, subtree: true };

    // Specify the target node, or document.body by default
    const targetNode = document.body;

    observer.observe(targetNode, config);
})